import { abbrNumber } from '@hotjar/insights-common/lib/number';

export function composePlanName(planName: string, allowance: number): string {
  if (planName !== 'business') {
    return planName;
  }

  return `${planName} ${abbrNumber(allowance)}`;
}
